import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=86753d3a&scoped=true"
import script from "./StatusLabel.vue?vue&type=script&lang=ts"
export * from "./StatusLabel.vue?vue&type=script&lang=ts"
import style0 from "./StatusLabel.vue?vue&type=style&index=0&id=86753d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86753d3a",
  null
  
)

export default component.exports